import '../../style/index.less'
import './index.less'

// style dependencies
import '../../checkbox/style'
import '../../button/style'
import '../../input/style'



// WEBPACK FOOTER //
// ./components/transfer/style/index.js